import { OnaWordmark } from "@/assets/icons/OnaWordmark";
import { OnboardingStepIndicator } from "@/routes/ona-onboarding/OnboardingStepIndicator";

export function OnboardingHeader() {
    return (
        <div className="flex w-full items-center justify-between px-6 py-4">
            <OnaWordmark className="h-6 w-auto" />
            <OnboardingStepIndicator />
        </div>
    );
}
